export const APP_ROUTES = {
  home: "/",
  installExtension: "/install-extension",
  auth: "/auth",
  pipedriveSettings: "/pipedrive-settings",
  specialOffers: "/special-offers",
  team: "/team",
  dashboard: "/dashboard",
  billing: "/billing",
  aicredits: "/credits",
  fieldsMapping: "/fields-mapping",
  toolsAndApps: "/tools-and-apps",
  aiSettings: "/settings",
  aiTemplates: "/cover-letters",
  autoBidding: "/auto-bidding",
  aiLeadGenerator: "/ai-job-researcher",
  releaseNotes: "/release-notes",
  registration: "/sign-up",
  plans: "/plans",
  pipedrive: "/pipedrive/callback",
  login: "/login",
  uninstallFeedback: "/uninstall",
  extensionSignOut: "/ex-sign-out",
  extensionAuth: "/extension-auth",
  paymentProcessing: "/payment-processing",
  featureRequest: "/feature-request",
  proposals: "/proposals",
  // Staff-only support inbox. Notification emails link to this exact path.
  support: "/support",
  api: "/api",
  paymentBotProcessing: "/bot-billing/success",
  // extension routes
  extensionGeneral: "/extension/general",
  extensionJobScoreDetails: "/extension/job-score-details",
  extensionUserProfile: "/extension/user-profile",
  extensionAnalytics: "/extension/analytics",
  extensionDeals: "/extension/deals",
  extensionCRM: "/extension/crm",
  extensionPrompts: "/extension/prompts",
  extensionPromptCreate: "/extension/prompts/create",
  extensionPromptEdit: "/extension/prompts/edit",
  extensionSettings: "/extension/settings",
};
